import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";

import moment from "moment";

import rules from "../../../utils/rules";
import schedulerDialog from "@/components/SchedulerDialog";

export default {
  name: "planned-vs-actual-report",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      input: {},
      loadergetcalls: true,
      reportsList: [],
      selectedPlan: "",
      reportsListDropDown: [],
      isReportLoadingDropDown: false,
      isReportLoading: false,
      fromDate: "",
      toDate: "",
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,
      showDrop: false,
      header: [],
      csvName: "Planned vs Actual.xlsx",
      pdfName: "Planned vs Actual.pdf",
      isDownloadCSV: false,
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },

        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",
      planSearchFilter: "",
      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "PLANNEDVSACTUAL",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      selectedcust: "",
      isExtended: false,
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      birchcustid: "",
      custid: "",
      custnum: "",
      rules: rules,
      selectedPlanSchedule: "",
      selectedExportOption: null,
      isDownloading: false,
      exportOptions: ["Excel"],
      closeOnContentClick: false,
      // end scheduled reports data fields
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsBirchLinkingId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
    USCurrencyFormat: function (value) {
      if (value || value == 0) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("plannedVsActualReport", this.roles);
    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = "Please select customer to run the report";
      this.showDrop = false;
    } else {
      this.errorMSG = "";
      this.showDrop = true;
    }
    this.getReportListDropdown();
  },
  methods: {
    async getReportList() {
      this.isReportLoading = true;
      this.showTable = true;
      if (Number(this.selectedPlan) == 0) {
        this.isExtended = false;
      }
      try {
        let response = await smsService.getPlannedVsActualReport(
          Number(this.selectedPlan),
          this.isExtended
        );
        if (response.data && response.isSuccess) {
          this.reportsList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
          this.header = Object.keys(this.reportsList[0]);

          this.header = this.header.filter(
            (e) => e != "MaxDailyPlannedVsActual"
          );
          this.header.splice(3, 0, "MaxDailyPlannedVsActual");
          this.header = this.header.map((e) => {
            if (e == "SourceName") {
              return {
                text: "Source Name",
                value: e,
              };
            } else if (e == "ItemGroup") {
              return {
                text: "Equipment",
                value: e,
                width: "350px",
              };
            } else if (e == "sno") {
              return {
                text: "",
                value: "",
              };
            } else if (e == "PlannedDays") {
              return {
                text: "",
                value: "",
              };
            } else if (e == "ActualDays") {
              return {
                text: "",
                value: "",
              };
            } else if (e == "EstimatedRentalCostSummary") {
              return {
                text: "Estimated Rental Cost Summary ($) ",
                value: e,
                width: "80px",
              };
            } else if (e == "RentalSummary") {
              return {
                text: "Rental Summary",
                value: e,
                width: "80px",
              };
            } else if (e == "MaxDailyPlannedVsActual") {
              return {
                text: "Max Daily Planned Vs Actual",
                value: e,
                width: "100px",
              };
            } else if (e != "MaxDailyPlannedVsActual") {
              return {
                text: e,
                value: e,
              };
            }
          });
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.showTable = false;

          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    async getReportListDropdown() {
      this.isReportLoadingDropDown = true;

      try {
        let response = await smsService.getPlannedVsActualReportDropdown();
        if (response.data && response.isSuccess) {
          this.reportsListDropDown = response.data;

          this.isReportLoadingDropDown = false;
        } else {
          this.reportsListDropDown = [];
          this.isReportLoadingDropDown = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    clearFilters() {
      this.reportsList = [];
      this.isExtended = false;
      this.getReportList();
    },
    // scheduled reports api calls
    async downloadReport(exportOption) {
      try {
        if (Number(this.selectedPlan) == 0) {
          this.isExtended = false;
        }
        let response = await smsService.exportPlannedVsActualReport(
          exportOption,
          Number(this.selectedPlan),
          this.isExtended
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },

    OnFrequencyChange() {
      this.selectedDays = [];
    },
    // end scheduled reports methods
    splitedList(iconData) {
      if (iconData != "" && iconData != undefined && iconData != null) {
        let itemdata = iconData.split("/");
        return parseInt(itemdata[0], 10) > parseInt(itemdata[1], 10)
          ? "Green"
          : parseInt(itemdata[0], 10) < parseInt(itemdata[1], 10)
          ? "Red"
          : "N/A";
      } else {
        return "N/A";
      }
    },
  },
};
